import * as Yup from 'yup';

import { Form, Formik } from 'formik';
import React, { Component } from 'react';

import ApiService from '../../../service/api.service';
import Button from '../../../components/UI/Button/Button';
import Input from '../../../components/UI/Input/Input';
import RequiredInput from '../../../components/UI/Input/RequiredInput/RequiredInput';
import { Link } from 'react-router-dom';
import PageMeta from '../../../components/UI/PageMeta/PageMeta';
import SlickSlider from '../../../components/UI/SlickSlider/SlickSlider';
import forgotImage from '../../../assets/images/resetPasswordImg.svg';
import imageLogo from '../../../assets/images/Aura-big-logo.svg';
import loader from '../../../assets/images/loader.svg';
import SecurityFooter from '../../../components/UI/SecurityFooter/SecurityFooter';

class ForgotPassword extends Component {

    state = {
        forgotPassword: false,
        emailNotFound: '',
        buttonLoading: false
    }

    closeError = () => {
        this.setState({
            emailNotFound: null
        })
    }

    render() {

        let forgotPassword

        if(this.state.forgotPassword) {
            forgotPassword = (
                <>
                <div className="c-auth-page c-auth-page__forgot-password position-relative overflow-both-hidden margin-auto z-index-1 o-d-block-tablet o-flex-from-tablet width-full overflow-y-tablet">
                  {/* <img className="c-auth-page__bg-image position-absolute z-index-0" src={bgImage} alt="bgImage"/> */}
                  <div className="o-flex-from-tablet c-auth-page__info-wrapper margin-auto z-index-1 o-d-block-tablet o-flex-center o-flex-top o-flex-column width-full text-center">
                    <img className="margin-auto" src={forgotImage} alt="forgotImage"/>
                    <p className="font-18 text-center font-333 opacity-9">Your Password has been reset. We’ve sent instructions to your email address that will help you set up a new password</p>
                    <Link className="btn btn--full submit-button o-d-block-tablet position-relative overflow-both-hidden z-index-1 width-full text-center" to="/login">Back to Login</Link>
                  </div>
                  <SlickSlider />
                </div>
                </>
            );
        } else {
            forgotPassword = (
                <>
                <div className="o-flex o-flex-end o-flex-middle overflow-both-hidden position-relative c-auth-page o-d-block-tablet overflow-y-tablet">
                  <SecurityFooter tablet={true} />
                    <Formik
                        initialValues={{
                            email: '',
                            fullUserName: '',
                        }}
                        validationSchema={Yup.object({
                            email: Yup.string()
                                .email('Please enter a valid E-mail Address')
                                .required('This field is required.'),
                                fullUserName: Yup.string()
                        })}
                        onSubmit={ values => {
                            this.setState({
                                buttonLoading: true
                            }, () => {
                                let data
                                if (values.fullUserName === '') {
                                    data = {
                                        email: values.email
                                    }
                                } else {
                                    data = {
                                        email: values.email,
                                        user_full_name: values.fullUserName
                                    }
                                }
                                ApiService.forgotPassword(data).then(
                                    r => {
                                        this.setState({
                                            forgotPassword: true,
                                            buttonLoading: false,
                                        });
                                    }
                                ).catch(
                                    err => {
                                        this.setState({
                                            emailNotFound: 'Email address does not exist',
                                            resetPasswordDoading: false
                                        })
                                    }
                                )
                            })
                        }}
                        >
                        {props => (
                          <>
                            <div className="c-auth-page__auth-form margin-auto z-index-1 o-d-block-tablet o-flex-from-tablet o-flex-center o-flex-top o-flex-column width-full">
                              <PageMeta 
                                title="Forgot Your Password? | Aura" 
                                description="Forgot Your Password? | Aura"    
                                canonical={window.location.href}  
                              />
                            <a class="o-flex o-flex-center o-flex-middle width-full" href="/">
                                <img width="110" height="94" className="c-auth-page__auth-form--logo" src={imageLogo} alt="logo"/>
                            </a>
                              <p className="c-auth-page__auth-form--intro-text font-18">Enter your email address below...</p>
                              <Form noValidate>
                              {this.state.emailNotFound ? <div className="font-13 font-white font-semibold opacity-9 status-message-error o-flex o-flex-between"><p>{this.state.emailNotFound}</p><i className="icon-times font-white opacity-9 font-13" onClick={this.closeError}></i></div> : null}
                                 <RequiredInput label="Email Address" name="email" type="Email" />
                                 <div className="hide">
                                    <Input placeholder="Full User Name" name="fullUserName" type="text" />
                                 </div>
                                 <Button disabled={props.errors.email || props.values.email.length === 0} className={`btn--size-54 btn-loader ${this.state.buttonLoading ? 'save-in-progress' : ''} btn-loader btn btn--full submit-button width-full position-relative overflow-both-hidden z-index-1 reset-pass-btn`} type="submit">Reset Password <img width="100%" height="100%" src={loader} alt="loaderImage"/></Button>
                              </Form>
                              <h1 className="text-center width-full font-16 c-auth-page__auth-form--cta"><span>Don't have an Aura Account?</span> <span><Link className="link-underline" to="/register">Create one here!</Link></span></h1>
                            </div>
                            <SecurityFooter tablet={true} />
                          </>
                        )}
                        </Formik>
                    <SlickSlider />
                    </div>
                </>
            );
        }


        return forgotPassword
    }
}

export default ForgotPassword;
